export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.3.4-1315.37',
  commitId: 'f2e94e447e0660e0248916a199efc2d14c593e5d',
  commitTime: '2026-03-04T13:15:37.000Z',
});
